function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.28 387.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.38,325.94l.11,1.47a130.66,130.66,0,0,0-21-13.49,161.89,161.89,0,0,0-23.2-9.56A224.62,224.62,0,0,0,183,294.77a337.56,337.56,0,0,0-50.28-.26,369.46,369.46,0,0,0-44.38,5.8c.34-18.36.46-36.73.71-55.09l.28-60.55-.18-60.55-.25-22.67L79.33,90h-17l1.4,230.36c133.48-26.05,217.13,11,217.13,11Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.48,313.92a161.89,161.89,0,0,0-23.2-9.56A224.62,224.62,0,0,0,183,294.77a337.56,337.56,0,0,0-50.28-.26,369.46,369.46,0,0,0-44.38,5.8c.34-18.36.46-36.73.71-55.09l.28-60.55-.18-60.55-.62-56.91a315,315,0,0,1,41.1-7.2,277.24,277.24,0,0,1,45.45-1.45c15.12.91,30.25,3.18,44.63,8.09s28,12.3,39.13,23h0a93.12,93.12,0,0,0-17.36-15.29A113.85,113.85,0,0,0,220.9,63.41a166.5,166.5,0,0,0-45.34-10.8,264.44,264.44,0,0,0-46.66-.45,313.64,313.64,0,0,0-46.3,6.9l-3.43.79,0,3.73-.65,60.54-.19,60.55.28,60.55c.28,20.18.38,40.36.8,60.54l.12,5.63,5.39-1.32a356.63,356.63,0,0,1,48.46-8.1,329.75,329.75,0,0,1,49.28-1.6,227.61,227.61,0,0,1,48.76,7.05,159.9,159.9,0,0,1,23.35,8.07,131.08,131.08,0,0,1,21.76,11.92A130.66,130.66,0,0,0,255.48,313.92Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,135.82c28.55,63,56.09,53.38,75.47,65.53,27.33,17.13,27.8,24.93,1.27,100.08,32.41-17.53,36.49-81.34,24.79-133.65-7.15-31.95-20.19-59.62-36.26-69.8C216.7,172.55,146.78,208.09,98,135.82Z",
    style: {
      fill: "#1d1d1b",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.9,273.69c.91,11.17,2.49,26.37,2.74,25.67,8.4-23.73,12.67-40.84,7-70.4-.06,2.1-.16,4.2-.3,6.28A118.59,118.59,0,0,1,200.9,273.69Z",
    style: {
      fill: "#1d1d1b",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1,128.5A15.36,15.36,0,1,1,138,144.23,15.45,15.45,0,0,1,153.1,128.5Z",
    style: {
      fill: "#1d1d1b",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.19,199l-21.62,66.63s53.11,2.84,78.18-15.75-30.67-67.59-30.67-67.59Z",
    style: {
      fill: "#1d1d1b",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.38,251.28c5.64,9.68,11.51,18.73,10.9,18.3-20.45-14.66-31.71-22.3-44-49.77q1.88,2.53,3.84,5C253.88,234.41,263.94,244.34,275.38,251.28Z",
    style: {
      fill: "#1d1d1b",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,115.73A15.36,15.36,0,1,0,254.37,120,15.43,15.43,0,0,0,233,115.73Z",
    style: {
      fill: "#1d1d1b",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,132.69s-19.59-4.9-12.26,29.87C129.72,162.56,147.37,138.25,142,132.69Z",
    style: {
      fill: "#1d1d1b",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.08,230.61l-.86-2.34c-49.57-53.09,23.38-68,2.89-150.76,1.28,87.2-74.15,102.4-72.93,10.65-16.57,39.51,28.65,140,78.94,164.37Z",
    style: {
      fill: "#1d1d1b",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.14,249.71l-6.63-16.16L499,217.37,485.91,185l-6.66-16.13c-2.22-5.37-4.46-10.74-6.52-16.17l-1.6-4.12a21.37,21.37,0,0,0-1.53-3.36,15.47,15.47,0,0,0-4.63-5,15.13,15.13,0,0,0-12.83-1.95l.34-.11-38,14.61-3.94,1.52-2.32-3.68-2-3.16c-.66-1-1.36-2.22-1.89-3a6.6,6.6,0,0,0-1.39-1.41,6.35,6.35,0,0,0-1.8-.91,6.07,6.07,0,0,0-4,0l-6.77,2.64-28.18,10.36L334,165.4l-6.79,2a6.54,6.54,0,0,0-3.13,2.59,6.68,6.68,0,0,0-1,3.94c0,.68.28,2.12.44,3.33L324,181l.59,4.35-4.07,1.39-38.28,13.09.34-.13a10.65,10.65,0,0,0-4.21,3,12.42,12.42,0,0,0-2.46,4.88,19.09,19.09,0,0,0-.56,3,25.85,25.85,0,0,0-.15,3.11,18.27,18.27,0,0,0,1.33,6c3.27,9.5,6.49,18.88,9.62,28.39l4.74,14.21c1.53,4.77,2.9,9.59,4.26,14.42L303,305.74c-4.34-9-8.29-18.29-12-27.54l-5.76-13.79-5.57-13.9c-3.74-9.24-7.4-18.59-11-27.83a26.74,26.74,0,0,1-2.16-8.45,30.17,30.17,0,0,1,0-4.36,25.66,25.66,0,0,1,.62-4.38A21.61,21.61,0,0,1,271.1,197a19.89,19.89,0,0,1,7.59-5.93l.14-.06.2-.07,38-14.11-3.48,5.74-.57-3.7c-.17-1.27-.39-2.28-.55-4.09a17.32,17.32,0,0,1,10.64-17.25l1.37-.49.92-.28,1.79-.55,3.42-1.06,28-10.27,28.07-10.06,7.2-2.71a16.84,16.84,0,0,1,10.73.07,17,17,0,0,1,4.8,2.53,16.76,16.76,0,0,1,3.77,4c.9,1.31,1.41,2.31,2.08,3.39l1.92,3.21-6.26-2.16,38.39-13.65.19-.07.14,0a23.94,23.94,0,0,1,27.25,11.93,30.64,30.64,0,0,1,1.9,4.65l1.38,4.07,11.39,33c2,5.47,3.68,11,5.44,16.6l5.27,16.65C505.7,227.33,508.93,238.51,512.14,249.71Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.45,142c6-3.1,12.09-5.8,18.2-8.53l9.22-3.91c3.11-1.25,6-2.57,9.58-3.69a36.3,36.3,0,0,1,5.38-1.24,41.1,41.1,0,0,1,5.54-.34,32,32,0,0,1,11.17,2,28.68,28.68,0,0,1,16.21,16.05l.11.28.07.26c3.16,12.35,6.1,24.75,8.61,37.26,1.32,6.24,2.45,12.53,3.56,18.82s2.07,12.63,2.74,19c-2.52-5.93-4.68-12-6.85-18s-4.16-12.09-6-18.18c-3.88-12.16-7.34-24.42-10.58-36.75l.18.54a21.24,21.24,0,0,0-11.22-11.5,29.71,29.71,0,0,0-17.15-1.52c-2.92.55-6.2,1.67-9.41,2.48l-9.7,2.52C435.57,139.19,429.08,140.79,422.45,142Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.76,
    cy: 162.19,
    r: 11.85,
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.41,90c-.07-9.63-.2-20.7-.63-33.52l-.33-3.78L493,52.11a424,424,0,0,0-53.62-4.88A335.16,335.16,0,0,0,387,49.62c-17.36,2.23-34.6,6.22-50.83,12.91a123.72,123.72,0,0,0-23,12.54,91.66,91.66,0,0,0-19,17.77c11.86-12.74,27.22-21.43,43.33-27.08s33.18-8.64,50.23-10.2A354.26,354.26,0,0,1,439,55.13a427.47,427.47,0,0,1,48.49,5.56s3,77.32,4.5,89.63a64.91,64.91,0,0,0,3.62,14.84l.06,19.49-.28,60.54c-.28,20.19-.37,40.37-.8,60.55l-.12,5.62L489.09,310A358.17,358.17,0,0,0,440.63,302a329.75,329.75,0,0,0-49.28-1.6,227.68,227.68,0,0,0-48.76,7,159.17,159.17,0,0,0-23.35,8.08,130,130,0,0,0-21.47,11.73l-3.44,4.12s84.9-30.13,218.38-4.08L514.12,90Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.15,183.73A57.9,57.9,0,1,1,379,187a57.9,57.9,0,0,1,19.16-3.27m0-6.65h0A64.53,64.53,0,1,0,459,220.26a64.45,64.45,0,0,0-60.88-43.18Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.4,293.53a63.8,63.8,0,0,1-94.79-44.69,63.57,63.57,0,0,1,11.81-48.58A63.85,63.85,0,0,1,389.12,175a63.66,63.66,0,0,1,68.51,81.43A63.49,63.49,0,0,1,428.4,293.53Zm0,0a61.46,61.46,0,0,0,17.85-15.9,58.91,58.91,0,0,0-33.71-92.53,58.77,58.77,0,0,0-43.11,6.29,56.75,56.75,0,0,0-16.74,14.45,58.28,58.28,0,0,0-10.28,19.74A58.86,58.86,0,0,0,405.71,301,61.41,61.41,0,0,0,428.4,293.53Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.85,235.45a44.3,44.3,0,0,0-5.73-16.32,42.25,42.25,0,0,0-3.27-4.73,15.11,15.11,0,1,1-24.72-15.78,43.83,43.83,0,0,0-7.54-1.11,46.25,46.25,0,0,0-8.62.38,44.93,44.93,0,0,0-8.43,2.08,45.6,45.6,0,0,0-7.91,3.65,47,47,0,0,0-6.94,5.07A42.91,42.91,0,0,0,362.9,215a42.47,42.47,0,0,0-4.53,7.48,43.5,43.5,0,0,0-3.95,25.27,45.7,45.7,0,0,0,5.72,16.32,42.94,42.94,0,0,0,11.44,12.76,45.3,45.3,0,0,0,7.43,4.51,44.17,44.17,0,0,0,8.2,3,41.83,41.83,0,0,0,8.5,1.34,46.68,46.68,0,0,0,8.58-.37,45.26,45.26,0,0,0,8.46-2.09,44.68,44.68,0,0,0,7.89-3.65,46.46,46.46,0,0,0,7-5.07,44.34,44.34,0,0,0,5.8-6.36,43,43,0,0,0,4.5-7.46,45.14,45.14,0,0,0,3-8.17,44.24,44.24,0,0,0,1.31-8.49A42.18,42.18,0,0,0,441.85,235.45Zm-43.71,11.08a6.1,6.1,0,1,1,6.09-6.09A6.09,6.09,0,0,1,398.14,246.53Z",
    style: {
      fill: "#1d1d1b",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3f8be962fd363468b2a47de242c5614a.svg";
export { ForwardRef as ReactComponent };